import { useMemo } from 'react';
import { formatDate, FormatDateType } from '../../../helpers/date';
import Clickable from '../Clickable/Clickable';
import { ClickableAction } from '../Clickable/consts';
import LegacyPicture from '../LegacyPicture/LegacyPicture';
import type { StageCardProps } from './interfaces';
import styles from './StageCard.module.scss';

const StageCard = ({
  headline,
  text,
  tag,
  date,
  image,
  linkintern,
}: StageCardProps) => {
  const formattedDate = useMemo(
    () => date && formatDate(new Date(date), FormatDateType.PressArticle),
    [date]
  );
  return (
    <article>
      <Clickable
        actionType={ClickableAction.Linkintern}
        linkintern={linkintern}
      >
        <div className={styles.base}>
          {image && <LegacyPicture asset={image} className={styles.image} />}
          <div className={styles.informations}>
            {tag && <div className={styles.category}>{tag}</div>}
            <div className={styles.headline}>{headline}</div>
            {text && <div className={styles.text}>{text}</div>}
            <div className={styles.date}>{formattedDate}</div>
          </div>
        </div>
      </Clickable>
    </article>
  );
};

export default StageCard;
